import { useEffect } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';
import { FilterableCheckboxList } from '../../../components/filterable-checkbox-list';
import { useGetCalendarV2QueriesData } from '../../../hooks/use-get-calendar-v2-queries-data';
import { useFilterPanelForm } from '../use-filter-panel-form';
import { PopoverMenuButton } from './popover-menu-button';

interface Props {
  onClose: () => void;
}

export const PopoverFilterPanelContentV2 = ({ onClose }: Props) => {
  const { t } = useTranslation('schedule');
  const { formField, isFiltersChanged, filterCounts, applyFilters, resetFilters, syncFilters } = useFilterPanelForm();
  const { filterLists } = useGetCalendarV2QueriesData();

  useEffect(() => {
    syncFilters();
    // NOTE: sync only when open the drawer to avoid overwrite unsaved changes
    // So don't add syncFilters to dependency array
  }, []);

  const handleApplyFilters = () => {
    applyFilters();
    onClose();
  };
  const handleResetFilters = () => {
    resetFilters();
    onClose();
  };

  return (
    <>
      <PopoverMenuButton
        iconName='pending-small'
        text={t('Appointment Status')}
        filterCount={filterCounts.apptStatuses}
      >
        <FilterableCheckboxList
          listStyle={listStyle}
          fieldName='apptStatuses'
          checkListField={formField.getFieldProps('apptStatuses')}
          list={filterLists.appointmentStatuses}
        />
      </PopoverMenuButton>
      <PopoverMenuButton iconName='tile-small' text={t('Appointment Types')} filterCount={filterCounts.apptTypes}>
        <FilterableCheckboxList
          listStyle={listStyle}
          fieldName='apptTypes'
          checkListField={formField.getFieldProps('apptTypes')}
          list={filterLists.appointmentTypes}
        />
      </PopoverMenuButton>
      <PopoverMenuButton iconName='user-small' text={t('Providers')} filterCount={filterCounts.providers}>
        <FilterableCheckboxList
          listStyle={listStyle}
          fieldName='providers'
          checkListField={formField.getFieldProps('providers')}
          list={filterLists.providers}
        />
      </PopoverMenuButton>
      <PopoverMenuButton
        iconName='shield-small'
        text={t('Insurance Status')}
        filterCount={filterCounts.insuranceStatuses}
      >
        <FilterableCheckboxList
          listStyle={listStyle}
          fieldName='insuranceStatuses'
          checkListField={formField.getFieldProps('insuranceStatuses')}
          list={filterLists.insuranceStatuses}
        />
      </PopoverMenuButton>
      <PopoverMenuButton iconName='department-small' text={t('Operatories')} filterCount={filterCounts.operatories}>
        <FilterableCheckboxList
          listStyle={listStyle}
          fieldName='operatories'
          checkListField={formField.getFieldProps('operatories')}
          list={filterLists.operatories}
        />
      </PopoverMenuButton>
      <div css={{ display: 'flex', gap: theme.spacing(1), marginTop: theme.spacing(1) }}>
        <Button variant='secondary' css={{ flex: 1 }} onClick={handleResetFilters} disabled={!filterCounts.total}>
          {t('Reset')}
        </Button>
        <Button css={{ flex: 1 }} onClick={handleApplyFilters} disabled={!isFiltersChanged}>
          {t('Apply')}
        </Button>
      </div>
    </>
  );
};

const listStyle = css({
  minHeight: 200,
  maxHeight: 400,
  overflowY: 'auto',
});
